<template>
  <div class="page-container">
    <div class="no-data" v-if="dataList.length == 0">
      <img class="logo" src="@/assets/images/licences/logo_no_data.png" alt="" />
      <div class="text">您还没有添加证照<br />请点击添加后进行亮证</div>
    </div>
    <div class="data-list" v-else>
      <van-swipe-cell class="licence-index" v-for="(item, index) in dataList" :key="'data' + index" right-width="60px">
        <div class="content" @click="openDetail(item.id)">
          <div :style="{ 'background-image': `url(${item.coverImg})` }" class="cover">电子证照</div>
        </div>
        <template #right>
          <img class="right-swiper-icon" src="@/assets/images/licences/icon_right_swiper_delete.png" alt="" @click="openDelete(item.id)" />
        </template>
      </van-swipe-cell>
    </div>
    <van-icon class="add-licence-btn" name="plus" @click="openAdd">添加电子证照</van-icon>
    <!-- 加载中遮罩层 -->
    <van-overlay :show="showLoading">
      <van-loading size="24px" class="loading-icon" type="spinner" color="#1989fa" />
    </van-overlay>
    <!-- 确认删除弹窗 -->
    <van-dialog v-model="showDeleteDialog" title="删除警告" show-cancel-button confirmButtonColor="#2F6CF5" @cancel="showDeleteDialog = false" @confirm="submitDelete">
      <div class="delete-text">确定要删除该证件吗？</div>
    </van-dialog>
    <!-- 要求实名弹窗 -->
    <van-popup v-model="showAuthentication" round :close-on-click-overlay="false">
      <div class="authentication-container">
        <div class="title">证照数据保护</div>
        <div class="text">您已开启证照数据保护，<br />此操作需要进行人脸识别~</div>
        <div class="text">此功能可在<br />“APP设置—证照数据保护”中关闭。</div>
        <div class="btns">
          <div class="btn default" @click="refuseAuthentication">稍后再说</div>
          <div class="btn primary" @click="openAuthentication">人脸识别</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import * as tokenUtils from '@/utils/TokenUtils'
import { Toast } from 'vant'
const SFApi = window.SFApi
const isInClient = SFApi.isInClient()
import { getList, deleteItem } from '@/service/system/licence.js'
export default {
  data() {
    return {
      dataList: [],
      showLoading: false,
      switchChecked: null,
      showAuthentication: false,
      showDeleteDialog: false,
      deleteId: ''
    }
  },
  computed: {
    isInClient() {
      return isInClient
    }
  },
  mounted() {
    this.checkRealName(this.loadingLicences)
  },
  methods: {
    checkRealName(doIt) {
      const that = this
      if (that.isInClient) {
        SFApi?.user.authentication((res) => {
          if (res == 1 && doIt) {
            const token = SFApi.user.getToken()
            tokenUtils.setToken(token)
            doIt()
          } else {
            Toast.fail('尚未实名')
            SFApi?.back()
          }
        })
      }
    },
    refuseAuthentication() {
      this.showAuthentication = false
      SFApi?.back()
    },
    openAuthentication() {
      const that = this
      SFApi.user.authentication((res) => {
        if (res == 1) {
          SFApi.user.faceRecognition((code) => {
            if (code == 1) {
              that.showAuthentication = false
              localStorage.setItem('prevAuthSwitchAt', new Date().getTime())
              that.$nextTick(() => {
                that.loadingLicences()
              })
            }
          })
        } else {
          Toast.fail('尚未实名')
          SFApi?.back()
        }
      })
    },
    async loadingLicences() {
      try {
        const data = await getList()
        this.dataList = JSON.parse(JSON.stringify(data))
      } catch (err) {
        Toast.fail(err)
      } finally {
        this.showLoading = false
      }
    },
    openDetail(typeId) {
      this.$router.push(`/licence-detail?typeId=${typeId}`)
    },
    openAdd() {
      this.$router.push('/licence-add')
    },
    openDelete(id) {
      this.deleteId = id
      this.showDeleteDialog = true
    },
    async submitDelete() {
      try {
        await deleteItem(this.deleteId)
        Toast.success('删除成功')
        this.loadingLicences()
      } catch (err) {
        Toast.fail(err)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.page-container {
  width 100%
  height 100%
  background-color #fff
  padding 30px
  overflow hidden auto
  position relative
  .no-data {
    padding-top 200px
    .logo {
      display block
      width 100%
      height auto
      margin auto
    }
    .text {
      text-align center
      font-size 30px
      color #4A4A4A
      line-height 44px
      margin-top 60px
    }
  }
  .loading-icon {
    position absolute
    top 50%
    left 50%
    transform  translate(-50%, -50%)
  }
  .authentication-container {
    width 660px
    background #FFFFFF
    border-radius 10px
    padding 52px 70px
    .title {
      line-height 48px
      font-size 34px
      font-weight 500
      color #333333
      text-align center
    }
    .text {
      text-align center
      margin-top 44px
      font-size 30px
      color #999999
      line-height 42px
    }
    .btns {
      margin-top 52px
      display flex
      justify-content space-between
      .btn {
        width 226px
        line-height 68px
        border-radius 34px
        font-size 32px
        font-weight 500
        text-align center
      }
      .default {
        border 2px solid #2D8DFF
        color #2D8DFF
      }
      .primary {
        background-color #2D8DFF
        color #fff
      }
    }
  }
  .delete-text {
    margin 20px 0
    text-align center
  }
  .data-list {
    padding-bottom 50px
  }
  .licence-index {
    width 100%
    height fit-content
    .content .cover {
      background-position 0 0
      background-repeat no-repeat
      background-size 100%
      width 100%
      border-radius 10px
      height 160px
      padding 94px 0 33px 60px
      font-size 24px
      color #999999
      line-height 33px
    }
    /deep/.van-swipe-cell__right {
      display flex
      align-items center
    }
    .right-swiper-icon {
      height 100px
      width 60px
      margin 0 20px 0 50px
    }
  }
  .licence-index+.licence-index {
    margin-top 20px
  }
  /deep/.add-licence-btn {
    position sticky
    bottom 20px
    display block
    margin 50px auto 0
    width 550px
    line-height 88px
    background #1070FF
    border-radius 44px
    font-size 32px
    font-weight 500
    color #FFFFFF
    text-align center
    &::before {
      margin-right 30px
    }
  }
}
</style>
